import { Select } from '@consta/uikit/Select'
import { Match, Switch } from '@library/components'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import type { MethodItemsType, RBFSelectItem } from '../types'
import { methodItems, rbfSelectItems } from '../types'
import {
  KrigingAlgorithmMenu,
  MinimalCurvatureAlgorithmMenu,
  MovingAverageAlgorithmMenu,
  SequentialConvergenceAlgorithmMenu,
} from './AlgorithmMenuItems'
import css from './MapBuildingRightMenu.css'
import type { AlgorithmMenuProps } from './types'

export const AlgorithmMenu: FC<AlgorithmMenuProps> = ({
  methodValue,
  formData,
  setMethodValue,
  updateKernelData,
  updateKrigingData,
  updateSequentialConvergenceData,
  updateMinimalCurvatureData,
  updateMovingAverageData,
}) => {
  const onMethodChange = (value: Nullable<MethodItemsType>) => {
    if (value) {
      setMethodValue(value)
    }
  }

  const onFunctionChange = (value: Nullable<RBFSelectItem>) => {
    updateKernelData(() => value?.key)
  }

  return (
    <div className={css.algorithmMenuContainer}>
      <Select
        label="Метод"
        className={`${css.algorithmMenuSelect} ${css.algorithmMenuSelectMargin}`}
        size="xs"
        items={methodItems}
        value={methodValue}
        getItemLabel={({ label }) => label}
        getItemKey={({ key }) => key}
        onChange={onMethodChange}
      />
      <Switch>
        <Match when={methodValue.key === 'RBF'}>
          <Select
            label="Тип функции"
            className={`${css.algorithmMenuSelect} ${css.algorithmMenuSelectMargin}`}
            size="xs"
            items={rbfSelectItems}
            value={rbfSelectItems.find(({ key }) => key === formData.kernel)}
            getItemLabel={item => item.label}
            getItemKey={item => item.key}
            onChange={onFunctionChange}
          />
        </Match>
        <Match when={methodValue.key === 'kriging'}>
          <KrigingAlgorithmMenu updateKrigingData={updateKrigingData} formData={formData} />
        </Match>
        <Match when={methodValue.key === 'sequentialConvergence'}>
          <SequentialConvergenceAlgorithmMenu
            updateSequentialConvergenceData={updateSequentialConvergenceData}
            formData={formData}
          />
        </Match>
        <Match when={methodValue.key === 'minimumCurvature'}>
          <MinimalCurvatureAlgorithmMenu
            updateMinimalCurvatureData={updateMinimalCurvatureData}
            formData={formData}
          />
        </Match>
        <Match when={methodValue.key === 'movingAverage'}>
          <MovingAverageAlgorithmMenu
            updateMovingAverageData={updateMovingAverageData}
            formData={formData}
          />
        </Match>
      </Switch>
    </div>
  )
}
